import { DragOverlay } from '@dnd-kit/core';
import { type PropsWithChildren, useEffect } from 'react';
import { createPortal } from 'react-dom';

const SortableListOverlay = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    if (children != null) {
      document.body.style.cursor = 'grabbing';
    }

    return () => {
      document.body.style.cursor = '';
    };
  }, [children]);

  const overlay = (
    <DragOverlay adjustScale dropAnimation={null} zIndex={1200}>
      <div className="scale-105 rounded-md bg-gray-100 shadow-lg transition-[transform,box-shadow] duration-2000 **:cursor-grabbing">
        {children}
      </div>
    </DragOverlay>
  );

  if (typeof document === 'undefined') {
    return overlay;
  }

  return createPortal(overlay, document.body);
};

export default SortableListOverlay;
